/**
 * The «Aprovações» hub: every approval page it holds, in menu order.
 *
 * One catalogue for the menu item, the route guard and the hub, so the three
 * never disagree on who sees what. `acls` is any-of and is exactly what used
 * to show the page's own menu item; `path` is that page's old route, now a
 * redirect into the hub; `indicatorKey` is its pending counter in the API's
 * `aprovacoes` indicator page.
 */
export const APPROVAL_ITEMS = [
  {
    value: "ferias",
    label: "Férias",
    icon: "pi pi-fw pi-slack",
    path: "/vacations-approve",
    acls: ["seeApproveVacations"],
    indicatorKey: "vacations.approve_pending",
  },
  {
    value: "faltas",
    label: "Faltas",
    icon: "pi pi-fw pi-user-minus",
    path: "/miss-approve",
    acls: ["seeMissApprove", "approveAllMiss"],
    indicatorKey: "miss.approve_pending",
  },
  {
    value: "despesas",
    label: "Despesas",
    icon: "pi pi-fw pi-euro",
    path: "/expenditure-approve",
    acls: ["seeExpenditureApprove"],
    indicatorKey: "expenditure.approve_pending",
  },
  {
    value: "horasExtra",
    label: "Horas Extra",
    icon: "pi pi-fw pi-clock",
    path: "/extra-hours-approve",
    acls: ["approveExtraHours"],
    indicatorKey: "extra_hours.to_approve",
  },
  {
    value: "processarHorasExtra",
    label: "Processar Horas Extra",
    icon: "pi pi-fw pi-check-square",
    path: "/extra-hours-process",
    acls: ["processExtraHours"],
    indicatorKey: "extra_hours.to_process",
    pendingLabel: "Por processar",
  },
  {
    value: "ajudasCusto",
    label: "Ajudas de Custo",
    icon: "pi pi-fw pi-dollar",
    path: "/costAssistenceAdmin",
    acls: ["seeApprovedCoastAssistence", "seeToApproveCoastAssistence"],
    indicatorKey: "cost_assistance.to_approve",
  },
  {
    value: "indisponibilidades",
    label: "Indisponibilidades",
    icon: "pi pi-fw pi-verified",
    path: "/booking/unavailability/toApprove",
    acls: ["approvesUnavailability"],
    indicatorKey: "support.unavailability_to_approve",
  },
];

/** Every alias that opens at least one item, i.e. the hub itself. */
export const APPROVAL_ACLS = [...new Set(APPROVAL_ITEMS.flatMap((item) => item.acls))];
